module.exports = __webpack_public_path__ + "fonts/RenaultLife-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Bold.woff
// module id = 348
// module chunks = 0